// extracted by mini-css-extract-plugin
module.exports = {"Client":"styles_Client__12Jnl"};